import { createContext } from 'react'

import type { CreatorsClustersContextData } from './types'

export const ClusterContext = createContext<CreatorsClustersContextData>({
  clusterId: null,
  setClusterId: () => {},
  clusterInfo: null,
  setClusterInfo: () => {},
  handleClusterClick: () => {},
})
